import { fetchPublicFeatures } from "./apiHelper";

// Passwordless sign-in modes (email code, optional password, sign-in method settings, Face ID /
// passkeys, OAB help form) are behind the runtime `signInModes` flag. The sign-in page is pre-auth,
// so it reads GET /features/public; anything but an explicit `true` keeps SignInLegacy.
export const PUBLIC_FEATURES_TIMEOUT_MS = 5000;

let cachedSignInModes = null;

export const resetSignInModesCache = () => {
  cachedSignInModes = null;
};

export const loadSignInModesEnabled = async ({ signal, timeoutMs = PUBLIC_FEATURES_TIMEOUT_MS } = {}) => {
  if (cachedSignInModes !== null) return cachedSignInModes;
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener?.("abort", abort);
  const timer = setTimeout(abort, timeoutMs);
  try {
    const features = await fetchPublicFeatures(controller.signal);
    cachedSignInModes = features?.signInModes === true;
    return cachedSignInModes;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener?.("abort", abort);
  }
};

// Backend sign-in methods (GET/PUT /users/me/sign-in-method).
export const SIGN_IN_METHOD_MODES = Object.freeze({
  CODE_ONLY: "CODE_ONLY",
  PASSWORD_AND_CODE: "PASSWORD_AND_CODE",
});

// Methods the user can pick. A legacy PASSWORD_ONLY from the backend is not one of them.
export const SELECTABLE_SIGN_IN_METHODS = Object.freeze([
  SIGN_IN_METHOD_MODES.CODE_ONLY,
  SIGN_IN_METHOD_MODES.PASSWORD_AND_CODE,
]);
